@if (configurations) {
  <div class="configuration-selector-list__header">{{ count }} {{ headerText }}</div>
  <div class="configuration-selector-list__body">
    <mat-accordion multi hideToggle displayMode="'flat'">
      @for (entry of configurations; track entry) {
        <mat-expansion-panel [expanded]="!isLeftSide" (click)="$event.stopPropagation()">
          <mat-expansion-panel-header
            #selectorPanel
            (click)="!isLeftSide ? selectorPanel._toggle() : null"
          >
            <mat-panel-title>
              @if (isLeftSide) {
                <div class="configuration-selector__available-title">
                  <div class="open-icon">
                    <xi-icon icon="tree_picker_expand"></xi-icon>
                  </div>
                  <div class="close-icon">
                    <xi-icon icon="tree_picker_collapse"></xi-icon>
                  </div>
                  <span>{{ entry.languageName }}</span>
                </div>
              }
              @if (!isLeftSide) {
                <span class="configuration-selector__selected-title">{{ entry.languageName }}</span>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (config of entry.configurations; track config) {
            <div class="configuration-selector-list__entry-body">
              <xi-custom-pill color="CXIC" [text]="config.pillType"></xi-custom-pill>
              <div class="configuration-selector-list__entry-name">
                <ng-container *appMiddleEllipsize="config.configuration.name"></ng-container>
              </div>
              <xi-default-button
                [text]="buttonText"
                buttonSize="small"
                (onClick)="onConfigurationClicked(config)"
              ></xi-default-button>
            </div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
}
